export default {
    methods: {
        completionClickHandler({ event, completion, position, source, customEventType }, callback) {
            switch (completion.label) {
            case 'offers':
                this.$emit('offer-click', {
                    ...completion,
                    source: 'productClickCompletions',
                    pos: position,
                    event,
                    customEventType,
                });
                break;
            case 'categories':
                this.$emit('category-click', {
                    ...completion,
                    source: 'categoryClick',
                    pos: position,
                    event,
                    customEventType,
                });
                callback(completion);
                break;
            default:
                if (event.button === 2) return;
                callback(completion);
                break;
            }
        },
    },
};
